import { vec2 } from "@tlaukkan/tsm";

export type InterpolationFunction = (from: number, to: number, progress: number) => number;

export function lerp(from: number, to: number, progress: number) {
	return from * (1 - progress) + to * progress;
}

export function lerp2D(from: vec2, to: vec2, progress: number, dest = new vec2()) {
	dest.xy = [lerp(from.x, to.x, progress), lerp(from.y, to.y, progress)];
}

export function smoothStepInterp(from: number, to: number, progress: number) {
	var step = progress * progress * (3 - 2 * progress);
	return lerp(from, to, step);
}

//reference: https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
export function easeInCubic(from: number, to: number, progress: number) {
	const t = progress * progress * progress;
	return from * (1 - t) + to * t;
}

export function easeOutCubic(from: number, to: number, progress: number) {
	const t = (--progress) * progress * progress + 1
	return from * (1 - t) + to * t;
}

export function easeInElastic(x: number): number {
	const c4 = (2 * Math.PI) / 3;

	return x === 0
		? 0
		: x === 1
			? 1
			: -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4);
}


export function easeOutElastic(from: number, to: number, progress: number) {
	if (progress == 0) {
		return from;
	}
	if (progress == 1) {
		return to;
	}
	return to * -Math.pow(2, 10 * progress - 1) * Math.sin(progress - .1) * (2 * Math.PI) / 0.4;
}